import { render, staticRenderFns } from "./result-pay.vue?vue&type=template&id=fa615242&scoped=true&"
import script from "./result-pay.vue?vue&type=script&lang=js&"
export * from "./result-pay.vue?vue&type=script&lang=js&"
import style1 from "./result-pay.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa615242",
  null
  
)

export default component.exports